// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602061203/js/" + chunkId + "." + {"44":"88c43ccc","225":"60fff70c","481":"97079e42","486":"22950c8b","770":"e11f6260"}[chunkId] + ".0.5388807681443459.chunk.js";
};